import React, { useState } from 'react';
import { Send, Check, Mail, Phone, MapPin } from 'lucide-react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    email: '',
    telephone: '',
    zone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      // Envoi vers le backend Trofy (ou Slack directement)
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
      const response = await fetch(`${backendUrl}/demo-leads/procumatcher`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...formData, source: 'landing' }),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de l\'envoi');
      }

      setIsSubmitted(true);
      setFormData({ email: '', telephone: '', zone: '', message: '' });
    } catch (err) {
      console.error('Erreur:', err);
      setError('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact__container container">
        <div className="contact__grid">
          <div className="contact__info">
            <span className="contact__label">Contact</span>
            <h2 className="contact__title">
              Pour toute question et formation
            </h2>
            <p className="contact__description">
              Décrivez-nous votre campagne électorale et recevez une proposition adaptée à vos besoins.
            </p>
            
            <div className="contact__details">
              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <Mail size={20} />
                </div>
                <div>
                  <strong>Email</strong>
                  <a href="mailto:contact@rodium.fr">contact@rodium.fr</a>
                </div>
              </div>
              
              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <Phone size={20} />
                </div>
                <div>
                  <strong>Téléphone</strong>
                  <a href="tel:+33142560944">01 42 56 09 44</a>
                </div>
              </div>
              
              <div className="contact__detail">
                <div className="contact__detail-icon">
                  <MapPin size={20} />
                </div>
                <div>
                  <strong>Adresse</strong>
                  <span>256 rue Marcadet, 75018 Paris</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="contact__form-wrapper">
            {isSubmitted ? (
              <div className="contact__success">
                <div className="contact__success-icon">
                  <Check size={40} />
                </div>
                <h3>Merci pour l'envoi !</h3>
                <p>Nous allons vous contacter dans les plus brefs délais.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact__form">
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="votre@email.fr"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="telephone">Téléphone</label>
                  <input
                    type="tel"
                    id="telephone"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    placeholder="06 12 34 56 78"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="zone">Zone de campagne</label>
                  <input
                    type="text"
                    id="zone"
                    name="zone"
                    value={formData.zone}
                    onChange={handleChange}
                    placeholder="Ex: Paris 15ème, Lyon 3ème..."
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Décrivez votre projet..."
                  />
                </div>
                
                {error && (
                  <div className="form-error">{error}</div>
                )}
                
                <button type="submit" className="form-submit" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <span className="form-submit__loading" />
                  ) : (
                    <>
                      <Send size={18} />
                      Envoyer
                    </>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;

